import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'

import { Colors, FontSize } from '~/styles'

const ConfirmDialog = styled(Dialog)`
  div.MuiDialog-container.MuiDialog-scrollPaper {
    div.MuiDialog-paperWidthMd {
      width: ${(props) => props.width}vw;
      max-width: none;
      padding: 24px;
      ${(props) => props.height ? `height: ${props.height}${props.heightType ? props.heightType : 'vh'};` : ''}
    }
    div.MuiDialog-paperWidthXl {
      width: ${(props) => props.width}vw;
    }
  }
`

const ConfirmContent = styled.div`
  gap: 16px;
  display: flex;
  margin-bottom: 24px;
  flex-direction: column;
`

const ConfirmAction = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  justify-content: flex-end;
`

const ConfirmTitle = styled.h4`
  margin: 0;
  color: ${Colors.cancelTextColor};
  font-weight: bold;
  font-size: ${FontSize.extraLarge}px;
`

const ConfirmDesc = styled.p`
  color: ${Colors.modalGrey};
  margin: 0;
  font-size: ${FontSize.medium}px;
  text-align: left;
  font-weight: 400;
`

export const ConfirmHeader = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  justify-content: space-between;
`

export default {
  ConfirmDesc,
  ConfirmTitle,
  ConfirmDialog,
  ConfirmAction,
  ConfirmHeader,
  ConfirmContent,
}